import { Component, OnInit, Input } from '@angular/core';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq15',
  templateUrl: './cq15.component.html',
  styleUrls: ['./cq15.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq15Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  showbutton = true;
  userResponses = [];
  index;
  questionObj;
  deviceWidth;
  yes_id;
  no_id;
  yes_no;
  switchDates = [];
  addresses = [];
  location_addAddresses = [];

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
    if (this.commercialService.modifyAddress === true) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': '0015' });
      if (obj !== undefined) {
        this.commercialService.serialNumber = obj.fieldValue.length-1;
      }
    }
    this.commercialService.modifyAddress = false;
    // this.commercialService.serialNumber = null;
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.yes_id = document.getElementById('yes_mob_q15');
      this.no_id = document.getElementById('no_mob_q15');
    } else {
      this.yes_id = document.getElementById('yes');
      this.no_id = document.getElementById('no');
    }

    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      const addressObj = _.findWhere(this.userResponses, {'com_question_id': '004'});
      const servicesObj = _.findWhere(this.userResponses, {'com_question_id': '009'});
      const spSwitch = _.findWhere(this.userResponses, {'com_question_id': '0011'});
      const nsSwitch = _.findWhere(this.userResponses, {'com_question_id': '0013'});
      this.addresses = addressObj.fieldValue;
      const services = servicesObj.fieldValue;
      for (let i = 0; i < this.addresses.length; i++) {
        if (services[i].value === 'New Service') {
          this.switchDates.push(nsSwitch.fieldValue[i]);
        } else {
          this.switchDates.push(spSwitch.fieldValue[i]);
        }
      }
      const dates = [];
      _.each(this.switchDates, function(item){
        dates.push(new Date(JSON.parse(item.value.date)));
      });
      this.switchDates = dates;
      if (!_.isEmpty(obj)) {
        if (!_.isEmpty(obj.fieldValue)) {
          this.location_addAddresses = obj.fieldValue;
          if (!this.commercialService.addAddress && !_.isEmpty(this.location_addAddresses)) {
            let index;
            if (this.commercialService.serialNumber === null) {
              index = this.location_addAddresses.length - 1;
            } else if (this.commercialService.serialNumber !== null) {
              index = this.commercialService.serialNumber;
            }
            if (!_.isEmpty(this.location_addAddresses[index])) {
              this.yes_no = this.location_addAddresses[index].value;
              this.getAcceptance(this.yes_no);
            } else {
              if (_.contains(this.yes_id.classList, 'active-select')) {
                this.yes_id.classList.remove('active-select');
              }
              if (_.contains(this.no_id.classList, 'active-select')) {
                this.no_id.classList.remove('active-select');
              }
              this.yes_no = '';
              this.user_bot = false;
            }
          } else {
            if (_.contains(this.yes_id.classList, 'active-select')) {
              this.yes_id.classList.remove('active-select');
            }
            if (_.contains(this.no_id.classList, 'active-select')) {
              this.no_id.classList.remove('active-select');
            }
            this.yes_no = '';
            this.user_bot = false;
          }
        } else {
          if (_.contains(this.yes_id.classList, 'active-select')) {
            this.yes_id.classList.remove('active-select');
          }
          if (_.contains(this.no_id.classList, 'active-select')) {
            this.no_id.classList.remove('active-select');
          }
          this.yes_no = '';
          this.user_bot = false;
        }
      } else {
        if (_.contains(this.yes_id.classList, 'active-select')) {
          this.yes_id.classList.remove('active-select');
        }
        if (_.contains(this.no_id.classList, 'active-select')) {
          this.no_id.classList.remove('active-select');
        }
        this.yes_no = '';
        this.user_bot = false;
      }
    }

    if(!_.contains(this.yes_id.classList, 'active-select') && !_.contains(this.no_id.classList, 'active-select'))
    {
      this.showbutton = false;
    }
  }

  getAcceptance(event) {
    if (event === 'Yes' && !_.contains(this.yes_id.classList, 'active-select')) {
      if (_.contains(this.no_id.classList, 'active-select')) {
        this.no_id.classList.remove('active-select');
      }
      this.yes_id.classList.add('active-select');
      this.yes_no = 'Yes';
      this.commercialService.addAddress = true;
      this.commercialService.serialNumber = null;
      this.user_bot = true;
      this.save();
      if (this.deviceWidth < 768) {
        this.next();
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }

      }
    } else if (event === 'No' && !_.contains(this.no_id.classList, 'active-select')) {
      if (_.contains(this.yes_id.classList, 'active-select')) {
        this.yes_id.classList.remove('active-select');
      }
      this.no_id.classList.add('active-select');
      this.yes_no = 'No';
      this.commercialService.addAddress = false;
      // this.commercialService.serialNumber = null;
      this.user_bot = true;
      this.save();
      if (this.deviceWidth < 768) {
        this.next();
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }

      }
    }
  }

  markerIconUrl() {
    return require('../../../../../assets/images/map-marker-2.png');
  }

  modify(index) {
    this.save();
    this.commercialService.addAddress = false;
    this.commercialService.serialNumber = index;
    this.commercialService.modifyAddress =  true;
    this.commercialService.messageService({'currentId': '003'});
  }

  save() {
    if (this.commercialService.serialNumber !== null) {
      this.location_addAddresses[this.commercialService.serialNumber] = {'serialNo': this.commercialService.serialNumber + 1, 'value': this.yes_no};
    } else if (this.commercialService.serialNumber === null) {
      this.location_addAddresses.push({'serialNo': this.location_addAddresses.length + 1, 'value': this.yes_no});
    }
    const Obj = {
      'com_question_id': this.data,
      'fieldName': 'Add another address',
      'fieldValue': this.location_addAddresses
    };
    this.commercialService.updateResponses(Obj);
  }

  next() {
    if (_.isEmpty(this.yes_no)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      if (this.yes_no === 'Yes') {
        this.commercialService.addAddress = true;
        this.commercialService.serialNumber = null;
      } else {
        this.commercialService.addAddress = false;
      // this.commercialService.serialNumber = null;
      }
      this.commercialService.messageService({'currentId': this.data});
    }
  }
  setPos(val) {
    if (typeof(val) === 'number') {
      return val;
    } else {
      return val();
    }
  }

}
